import { createAction, props } from '@ngrx/store';
import * as modelUsr from '../models/usuario.model';
import {Usuario} from "../models/usuario.model";

export const CARGAR_USUARIO = '[Usuario] Cargar datos del usuario';

export const solicitarDatosUsuarioAcc = createAction(
    '[Usuario] Solicitar Datos Usuario'
);

export const obtenerUsuarioSuccessAcc = createAction(
    '[Usuario] SUCCESS Obtener Usuario',
    props<{ Usuario: modelUsr.Usuario }>()
);

export const cargarUsuario = createAction(
  CARGAR_USUARIO,
  props<Usuario>()
);


export const obtenerUsuarioErrorAcc = createAction(
    '[Usuario] ERR Obtener Usuario',
    props<{ payload: any }>()
);

export const resetDatosUsuarioAcc = createAction(
    '[Usuario] Reset Datos Usuario'
);



